import { configureStore } from "@reduxjs/toolkit";

import loader from "./loader/reducer";

const store = configureStore({
  reducer: {
    loader,
  },
});

export default store;

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;